import { render, staticRenderFns } from "./ArticleRenderer.vue?vue&type=template&id=734a6d44&scoped=true&"
import script from "./ArticleRenderer.vue?vue&type=script&lang=js&"
export * from "./ArticleRenderer.vue?vue&type=script&lang=js&"
import style0 from "./ArticleRenderer.vue?vue&type=style&index=0&id=734a6d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734a6d44",
  null
  
)

export default component.exports